<script setup lang="ts">
import { storeToRefs } from 'pinia'
import LinkList from './LinkList.vue'
import { AppStore } from '~/lib/services/content/content.configuaration.dtos'
import { Link } from '~/lib/services/content/content.shared.dtos'

const layoutStore = useLayoutStore()
const { menuProductsPath } = useRestaurantActions()
const { isMenuSideBarOpen } = storeToRefs(layoutStore)
const isMobile = inject('isMobile')
const { t } = useLocale()
const site = useSite()
const sideBarSections = site?.sideBar?.sections
const configuration = site?.configuration
const appStoresLinks = configuration.find(
  config => config.__component === 'configuration.app-stores'
) as AppStore

const linkList = computed(() => {
  const headerLinks = site.header?.mainLinks
  if (!headerLinks) return undefined
  const productsLink: Link = {
    title: t('routes.staticMenu.linkTitle'),
    url: '',
    blank: false,
    download: false,
    action: null,
    page: null,
    icon: { id: 0, height: 30, width: 30, url: '/images/icons/products/meal-item.svg' },
  }
  productsLink.url = menuProductsPath.value || ''
  return [productsLink, ...headerLinks]
})
</script>
<template>
  <Sidebar v-model:visible="isMenuSideBarOpen" :position="isMobile ? 'full' : 'left'">
    <div class="flex h-full flex-col justify-between px-8">
      <div>
        <LinkList v-if="linkList" :links="linkList" />
        <template v-if="sideBarSections">
          <template v-for="link of sideBarSections" :key="link.name">
            <LinkList :title="link.name" :links="link.links" />
          </template>
        </template>
      </div>
      <div class="flex w-72 flex-col gap-6 py-8">
        <h2 class="flex flex-col text-2xl">
          {{ t('sidebar.title.normal') }}
          <span class="font-bold">{{ t('sidebar.title.bold') }}</span>
        </h2>
        <div class="flex gap-2">
          <template v-for="store of appStoresLinks.items" :key="store.id">
            <DownloadAppPill
              :url="store?.link?.url"
              :name="store.title"
              :icon-url="store.icon?.url"
            />
          </template>
        </div>
      </div>
    </div>
  </Sidebar>
</template>

<style>
.p-sidebar-header {
  justify-content: flex-start !important;
}

.p-sidebar {
  width: 480px !important;
  @apply text-mcd-black;
}

.p-sidebar-content {
  padding: 0 !important;
  display: flex !important;
  flex-direction: column !important;
}
</style>
